import { getAddressDisplay } from 'lib/helpers/address';
import { formatPhoneNumber } from 'lib/helpers/utility';

export const getPracticeAddressLine = (address) => {
  if (!address || typeof address !== 'object') return getAddressDisplay(address) || '';

  const street = [address.address_ln_1, address.address_ln_2].filter(Boolean).join(', ');
  const state =
    address.addressState?.abbreviation || (typeof address.state === 'string' ? address.state : '');
  const locality = [address.city, [state, address.zip].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ');

  const line = [street, locality].filter(Boolean).join(' · ');

  return line || getAddressDisplay(address) || '';
};

export const getPracticeContactLine = (practice) =>
  [formatPhoneNumber(practice?.phone), practice?.email, practice?.website]
    .filter(Boolean)
    .join(' · ');

export const getPracticeName = (practice) =>
  practice?.displayName || practice?.display_name || practice?.name || '';
